import { inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavigationItem } from '../models/navigation-item';
import { AppUtil } from '../utility/app-util';
import { MenuAs } from '../models/interface/auth';
import { SecurityService } from './security-service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    // Signal que representa si el menú está abierto o no
    private _isSidebarOpen = signal(true);
    private menusSubject = new BehaviorSubject<NavigationItem>(new NavigationItem);
    menus$ = this.menusSubject.asObservable();
    // Exponer el signal como readonly
    isSidebarOpen = this._isSidebarOpen.asReadonly();
    router = inject(Router);

    toggleSidebar() {
        this._isSidebarOpen.update((open) => !open);
    }

    setSidebarState(state: boolean) {
        this._isSidebarOpen.set(state);
    }


    clearMenus() {
        this.menusSubject.next(new NavigationItem); // limpia
        AppUtil.clearMenus()
    }

    setMenus(menus: NavigationItem, menuJson: MenuAs[]) {
        AppUtil.setMenus(menuJson)
        this.menusSubject.next(menus); // actualiza con nuevos
    }

    goToLogin() {
        SecurityService.clearSessionData();
        this.router.navigate(['login'])
    }

    goSignOut() {
        SecurityService.clearSessionData();
        this.router.navigate(['/login']);
    }

}
